<template>
  <section id="factor-payment">
    <div class="container">
      <div class="row">
        <div class="col-md-1 mt-5 mx-auto">
          <div class="text-center">
            <img
              src="../../../assets/media/logo.png"
              alt=""
              width="100px"
            />
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-8 mx-auto py-4 mb-5">
          <div class="card bg-white p-4" id="cardPaymentData">
            <div class="text-center">
              <div class="container" v-if="payDetails[0].payment_status === '2'">
                <div class="row">
                  <div class="col-md-6 mx-auto">
                    <img
                      src="@/assets/media/paid_stamp.png"
                      alt="Paid_Stamp"
                      width="200px"
                    />
                  </div>
                </div>
              </div>
              <div class="container" v-if="payDetails[0].payment_status === '1'">
                <div class="row">
                  <div class="col-md-6 mx-auto">
                    <img
                      src="@/assets/media/canceled_stamp.jpg"
                      alt="Canceled_Stamp"
                      width="200px"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="d-flex flex-row align-items-center justify-content-center c_pointer"
              id="personal_info"
            >
              <a :href="`mailto:?subject=&body=${locHref}`">
                <div
                  class="bg-light px-2 py-2 d-flex align-items-center justify-content-center c_pointer"
                  style="border-radius: 50%"
                >
                  <i class="fa fa-envelope"></i>
                </div>
              </a>
              <a :href="`https://telegram.me/share/url?url=${locHref}&text=`">
                <div
                  class="bg-light px-3 py-3 d-flex align-items-center justify-content-center"
                  style="border-radius: 50%"
                >
                  <i class="fab fa-telegram"></i>
                </div>
              </a>
              <div v-if="payDetails[0].customer.image !== null">
                <img
                  :src="`${payDetails[0].customer.image}`"
                  style="width: 100px; border-radius: 50%"
                  alt=""
                />
              </div>
              <div v-else>
                <img
                  src="../../../assets/media/defaultCustomer.jpeg"
                  style="width: 100px; border-radius: 50%"
                  alt=""
                />
              </div>
              <a :href="`https://twitter.com/intent/tweet?url=${locHref}`">
                <div
                  class="bg-light px-3 py-3 d-flex align-items-center justify-content-center c_pointer"
                  style="border-radius: 50%"
                >
                  <i class="fab fa-twitter"></i>
                </div>
              </a>
              <a :href="`https://api.whatsapp.com/send?text=${locHref}`">
                <div
                  class="bg-light px-2 py-2 d-flex align-items-center justify-content-center c_pointer"
                  style="border-radius: 50%"
                >
                  <i class="fab fa-whatsapp"></i>
                </div>
              </a>
            </div>
            <!-- Customer Name -->
            <div class="text-center mt-4">
              <h5 class="text-dark font-weight-bold">{{ payDetails[0].customer.name }}</h5>
            </div>
            <hr />
            <div class="text-center mt-4">
              <h5 class="text-dark font-weight-bold">{{ payDetails[0].title }}</h5>
              <p>{{ 'ایجاد شده توسط: ' + payDetails[0].creator.name }}</p>
            </div>
            <div
              class="d-flex flex-row align-items-center justify-content-between factorpayments"
            >
              <div class="d-flex flex-column text-dark my-3">
                <h5>{{ payDetails[0].customer.name }}</h5>
                <p dir="ltr">{{ payDetails[0].customer.mobile }}</p>
                <p>{{ payDetails[0].customer.email }}</p>
              </div>
              <div class="d-flex">
                <div class="mr-5">
                  <p>تاریخ فاکتور</p>
                  <span>{{ payDetails[0].sending_date }} </span>
                </div>
                <div>
                  <p>شماره فاکتور</p>
                  <span v-if="payDetails[0].code !== null">
                    {{ payDetails[0].code }}</span
                  >
                  <span v-else> ______</span>
                </div>
              </div>
            </div>
            <!-- Table -->
            <table class="table">
              <thead class="thead-light text-center">
                <tr>
                  <th colspan="2">آیتم</th>
                  <th>تعداد</th>
                  <th>مبلغ آیتم</th>
                  <th>مجموع</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, idx) in payDetails[0].items"
                  :key="(item, idx)"
                  class="my-3"
                >
                  <td colspan="2">{{ item.title }}</td>
                  <td>{{ item.number }}</td>
                  <td>{{ item.unit_amount + " ریال" }}</td>
                  <td>{{ item.final_amount + " ریال" }}</td>
                </tr>
              </tbody>
            </table>
            <!-- Details Factor -->
            <div class="row">
              <div class="col-md-6 my-5 text-center">
                <qrcode-vue :value="payDetails[0].url" :size="size" level="M" />
                <div class="bg-light p-4 my-2" v-if="payDetails[0].message !== null">
                  <span>پیغام : </span>
                  <span>{{ payDetails[0].message }}</span>
                </div>
                <div class="bg-light p-4 my-2" v-if="payDetails[0].rules !== null">
                  <span>قوانین : </span>
                  <span>{{ payDetails[0].rules }}</span>
                </div>
              </div>
              <div class="col-md-6 my-5">
                <div class="d-flex align-items-start justify-content-between">
                  <h5>مبلغ کل</h5>
                  <p>{{ payDetails[0].final_amount + " ریال" }}</p>
                </div>
                <hr />
                <div class="d-flex align-items-start justify-content-between">
                  <h5>هزینه حمل و نقل</h5>
                  <p>{{ payDetails[0].shipping_cost + " ریال" }}</p>
                </div>
                <hr />
                <div class="d-flex align-items-start justify-content-between">
                  <h5>مجموع تخفیف</h5>
                  <p>{{ payDetails[0].discount_amount + " ریال" }}</p>
                </div>
                <hr />
                <div class="d-flex align-items-start justify-content-between">
                  <h5>مبلغ قابل پرداخت</h5>
                  <p class="text-primary font-weight-bold">
                    {{ payDetails[0].payment_amount + " ریال" }}
                  </p>
                </div>
              </div>
            </div>
            <!-- Button -->
            <div>
              <button
                class="btn btn-primary text-white col-md-6 c_pointer"
                @click="payMoney()"
                :disabled="!payBtn"
              >
                پرداخت
              </button>
              <button
                class="btn btn-light text-danger col-md-6 c_pointer"
                @click="cancelFactor()"
                :disabled="!payBtn"
              >
                لغو پرداخت
              </button>
            </div>
            <div
              class="mt-4 w-100 d-flex align-item-center justify-content-center c_pointer"
            >
              <div
                class="text-center c_pointer w-100"
                data-toggle="tooltip"
                data-placement="top"
                title="نسخه پرینت"
              >
                <p @click="printFactor()">
                  <img src="../../../../public/assets/media/print.png" alt="Print" />
                </p>
              </div>
              <div
                @click="generateReport()"
                class="text-center w-100 c_pointer"
                data-toggle="tooltip"
                data-placement="top"
                title="نسخه پی دی اف"
              >
                <img
                  src="../../../../public/assets/media/document.png"
                  alt="GeneratePdf"
                />
              </div>
            </div>
            <div>
              <vue-html2pdf
                :show-layout="false"
                :float-layout="true"
                :enable-download="true"
                :preview-modal="true"
                :paginate-elements-by-height="1400"
                filename="Factor Payment"
                :pdf-quality="2"
                :manual-pagination="false"
                pdf-format="a4"
                pdf-orientation="landscape"
                pdf-content-width="800px"
                @progress="onProgress($event)"
                @hasStartedGeneration="hasStartedGeneration()"
                @hasGenerated="hasGenerated($event)"
                ref="html2Pdf"
                name="test"
              >
                <section slot="pdf-content">
                  <!-- PDF Content Here -->
                  <div class="container" v-if="payDetails[0].payment_status === '2'">
                    <div class="row">
                      <div class="col-md-6">
                        <img
                          src="@/assets/media/paid_stamp.png"
                          alt=""
                          style="position: absolute; top: 50px; left: -550px"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="container" v-if="payDetails[0].payment_status === '1'">
                    <div class="row">
                      <div class="col-md-6">
                        <img
                          src="@/assets/media/canceled_stamp.jpg"
                          alt=""
                          style="position: absolute; top: 50px; left: -550px"
                          width="300px"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="container">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="text-center mt-4">
                          <h5 class="text-dark font-weight-bold">
                            {{ payDetails[0].creator.name }}
                          </h5>
                        </div>
                        <hr />
                        <div class="text-center mt-4">
                          <h5 class="text-dark font-weight-bold">
                            {{ payDetails[0].title }}
                          </h5>
                        </div>
                        <div
                          class="d-flex flex-row align-items-center justify-content-between"
                        >
                          <div class="d-flex flex-column text-dark my-3">
                            <h5>{{ payDetails[0].customer.name }}</h5>
                            <p dir="ltr">{{ payDetails[0].customer.mobile }}</p>
                            <p>{{ payDetails[0].customer.email }}</p>
                          </div>
                          <div class="d-flex">
                            <div class="mr-5">
                              <p>تاریخ فاکتور</p>
                              <span>{{ payDetails[0].sending_date }} </span>
                            </div>
                            <div>
                              <p>شماره فاکتور</p>
                              <span> {{ payDetails[0].code }}</span>
                            </div>
                          </div>
                        </div>
                        <!-- Table -->
                        <table class="table">
                          <thead class="thead-light text-center">
                            <tr>
                              <th>آیتم</th>
                              <th>تعداد</th>
                              <th>مبلغ آیتم</th>
                              <th>مبلغ قابل پرداخت</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, idx) in payDetails[0].items"
                              :key="(item, idx)"
                            >
                              <td>{{ item.title }}</td>
                              <td>{{ item.number }}</td>
                              <td>{{ item.unit_amount + " ریال" }}</td>
                              <td>{{ item.total_amount + " ریال" }}</td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- Details Factor -->
                        <div class="row">
                          <div class="col-md-6 my-5 text-center">
                            <qrcode-vue :value="payDetails[0].url" :size="size" level="M" />
                            <div
                              class="bg-light p-4 my-2"
                              v-if="payDetails[0].message !== null"
                            >
                              <span>پیغام : </span>
                              <span>{{ payDetails[0].message }}</span>
                            </div>
                            <div
                              class="bg-light p-4 my-2"
                              v-if="payDetails[0].rules !== null"
                            >
                              <span>قوانین : </span>
                              <span>{{ payDetails[0].rules }}</span>
                            </div>
                          </div>
                          <div class="col-md-6 my-5">
                            <div class="d-flex align-items-start justify-content-between">
                              <h5>مبلغ کل</h5>
                              <p>{{ payDetails[0].final_amount + " ریال" }}</p>
                            </div>
                            <hr />
                            <div class="d-flex align-items-start justify-content-between">
                              <h5>هزینه حمل و نقل</h5>
                              <p>{{ payDetails[0].shipping_cost + " ریال" }}</p>
                            </div>
                            <hr />
                            <div class="d-flex align-items-start justify-content-between">
                              <h5>مجموع تخفیف</h5>
                              <p>{{ payDetails[0].discount_amount + " ریال" }}</p>
                            </div>
                            <hr />
                            <div class="d-flex align-items-start justify-content-between">
                              <h5>مبلغ قابل پرداخت</h5>
                              <p class="text-primary font-weight-bold">
                                {{ payDetails[0].payment_amount + " ریال" }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </vue-html2pdf>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { onlineFactorService } from "@/common/api.service";
import QrcodeVue from "qrcode.vue";
import toastr from "toastr";
import VueHtml2pdf from "vue-html2pdf";
export default {
  name: "factorpayment",
  data() {
    return {
      payDetails: [],
      size: 100,
      locHref: window.location.href,
      payBtn: null,
    };
  },
  components: {
    QrcodeVue,
    VueHtml2pdf,
  },
  methods: {
    printFactor() {
      window.print();
    },
    payMoney() {
      onlineFactorService
        .payMoneyFactor(this.$route.params.hashid)
        .then((response) => {
          window.location.href = response.config.url;
        })
        .catch((error) => {
          throw new Error(error);
        });
    },
    cancelFactor() {
      onlineFactorService
        .cancelFactor(this.$route.params.hashid)
        .then((response) => {
          window.location.reload();
          toastr.info(response.data.message, {
            closeButton: true,
            positionClass: "toast-top",
            preventDuplicates: false,
            rtl: false,
          });
        })
        .catch((error) => {
          throw new Error(error);
        });
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
  },
  async created() {
    await onlineFactorService
      .paymentFactor(this.$route.params.hashid)
      .then((response) => {
        this.payDetails.push(response.data.data);
        this.payBtn = this.payDetails[0].payable;
        console.log(this.payDetails);
      })
      .catch((error) => {
        throw new Error(error);
      });
    document.body.scrollTop = 1;
    document.documentElement.scrollTop = 1;
  },
};
</script>

<style scoped>
ul {
  list-style: none;
}
#factor-payment {
  margin: -7rem 0;
  padding: 0;
  background: #83a4d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #b6fbff,
    #83a4d4
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #b6fbff,
    #83a4d4
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  width: 100%;
  height: auto;
}
.c_pointer {
  cursor: pointer;
}

#personal_info div {
  margin: 0 1rem;
}

tr:last-child {
  border-bottom: 1px solid #e9e9e9;
}

#cardPaymentData {
  border-radius: 20px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
@media screen and (max-width: 1000px) {
  .factorpayments {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center;
    margin: 1rem 0;
  }
  table {
    font-size: 9px;
    font-weight: 500;
  }
}
</style>
